import React, { useEffect, useCallback, useState, useRef } from 'react';
import classnames from 'classnames';
import { getCommentableTypeForDeviationType } from '../../redux/helpers';
import CommentBox from '../../../CommentBox/presets/CommentBox';
import s from './CommentBoxPanel.scss';
var CommentBoxPanel = function (_a) {
    var deviation = _a.deviation, focusEditor = _a.focusEditor, onClose = _a.onClose, onThreadUpdated = _a.onThreadUpdated, panelOpenEvent = _a.panelOpenEvent, panelCloseEvent = _a.panelCloseEvent;
    var rootRef = useRef(null);
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var editorId = "commentpanel-".concat(deviation.deviationId);
    var onPanelOpen = useCallback(function () {
        focusEditor(editorId);
    }, [editorId, focusEditor]);
    useEffect(function () {
        panelOpenEvent.addListener(onPanelOpen, true);
        /*
          A transitionend handler is put on the PanelPopup parent that uses scrollTo to follow along
          with any animations that it or it's children have, I guess? Uncertain of the original purpose.
    
          But we don't want that for our animation here, so stop propagation.
        */
        rootRef.current &&
            rootRef.current.addEventListener('transitionend', function (e) {
                return e.stopPropagation();
            });
        return function () {
            panelOpenEvent.removeListener(onPanelOpen);
        };
    }, [onPanelOpen, panelOpenEvent, rootRef]);
    var onPublishSuccess = useCallback(function (result) {
        // we wait for the panel animation's finish before the scroll,
        // otherwise it's a really janky effect
        panelCloseEvent.addListener(function () {
            onThreadUpdated(deviation, result);
        }, true);
        onClose();
    }, [panelCloseEvent, onThreadUpdated, deviation, onClose]);
    var handleEditorReady = useCallback(function () {
        setIsOpen(true);
    }, []);
    return (React.createElement("div", { className: classnames(s['root'], isOpen && s['open']), ref: rootRef },
        React.createElement("div", { className: s['wrapper'] },
            React.createElement(CommentBox, { id: editorId, commentableType: getCommentableTypeForDeviationType(deviation.typeId), commentableItemId: deviation.deviationId, onPublishSuccess: onPublishSuccess, onEditorReady: handleEditorReady, onClose: onClose, className: s['comment-box'], footerClassName: s['comment-box-footer'] }))));
};
CommentBoxPanel.displayName = 'CommentBoxPanel';
export default CommentBoxPanel;
//# sourceMappingURL=CommentBoxPanel.js.map